import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import axios from 'axios';
import SectionLoadingcontainer from './sectionloadingcontainer';
import { updateAppState,updateComponentState } from '../actions/actions';

class HealthFacility extends Component {
	constructor(props) {
		super(props);
		this.state = {
			healthfacility : [],
			loaderflag : true
		};
		this.onload = this.onload.bind(this);
		this.tileOnClick = this.tileOnClick.bind(this);
	}

	componentWillMount() {
		this.onload();
	}

	onload(){
		if(this.props.componentdata){
			this.setState({
				...this.props.componentdata
			});
		}else{
			axios.get(`/api/healthfacility`).then((response) => {
				if (response.data.message == 'success') {
					
					let healthfacility=[],totalhealthfacility=0;
					if(response.data.main && response.data.main.length > 0){
						response.data.main.forEach((item)=>{
							totalhealthfacility += item.total;
						});

						healthfacility = response.data.main;
					}
					this.setState({
						healthfacility,
						totalhealthfacility,
						loaderflag : false
					});

					this.props.updateComponentState(this.props.form,{
						healthfacility,
						totalhealthfacility,
						loaderflag : false
					});
				} else {
					console.log(response);
				}
			});
		}
	}

	tileOnClick(){
		if((this.props.app.companyid == 1 && ['Mumbai', 'Mumbai New','Tata'].includes(this.props.app.branch)) || this.props.app.companyid == 7){
			this.props.history.push("/healthfacilitybygroup");
		}else if(this.props.app.companyid == 6 || (this.props.app.companyid == 1 && ['Sysmex'].includes(this.props.app.branch))){
			this.props.history.push("/healthfacilitybystate");
		}else if (this.props.app.companyid == 8) {
			this.props.history.push({pathname: `/healthfacilitybyhospital/null`, params: {groupid: null,territoryid: null}});
		}else{
			this.props.history.push("/healthfacilitybydistrict");
		}
	}

	componentDidMount () {
		setTimeout(() => {
			let table_header_height = document.getElementsByClassName('healthfacility_header') ? document.getElementsByClassName('healthfacility_header')[0].clientHeight : 0;
			table_header_height = 200 - table_header_height - 29;
			this.setState({ table_header_height });
		}, 300);
	}

	render() {
		let {healthfacility,totalhealthfacility,loaderflag} = this.state;
		return (
			<div className="row no-gutters h-100" onClick={()=>{this.tileOnClick();}}>
				<div className="col-md-12">
					<SectionLoadingcontainer isloading={loaderflag}></SectionLoadingcontainer>
					<div className="row">
						<div className="col-md-12 section-header healthfacility_header">
							<div className="section-header-title" style={{float:'left',color: "#008060"}}>{this.props.app.companyid == 8 ? 'Department' : 'Health Facility'}</div>
							<div className="section-count" style={{float:'right',color: "#405FFF",display : "flex"}}><img style={{marginRight : "10px" }} src='/images/widget_icon_healthfacility.svg'/> {totalhealthfacility}</div>
						</div>
					</div>
					<div className="row">	
						<div className="col-md-12">
							<div className="gs-scrollbar" style={{overflow: 'auto', height: `${this.state.table_header_height}px`}}>
								{healthfacility.length > 0 ? <table className="table dashboardwidget">
									<tbody>
										{healthfacility.map((item, key) => {
											return <tr key={key}>
												<td className="text-left table-content">{item.name}</td>
												<td className="text-right table-body-count">{item.total}</td>
											</tr>
										})}
									</tbody>
								</table> : null}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

HealthFacility = connect(
	(state, props) => {
		let formName = 'healthfacility';

		return {
			app : state.app,
			form : formName,
			componentdata: state.componentdata[formName] ? state.componentdata[formName] : null
		}
	}, { updateAppState,updateComponentState }
)(reduxForm()(HealthFacility));

export default HealthFacility;


// WEBPACK FOOTER //
// ./public/react/components/healthfacility.js